import { useEffect, useRef, useState } from "react";
import printJS from "print-js";

import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import {
  Grid2x2,
  WalletCards,
  CircleStop,
  LoaderCircle,
  CircleOff,
  CircleCheck,
  Calendar,
  PrinterCheck,
  AlignJustify,
  Calculator,
  Send,
  Loader,
  Settings,
  CircleAlert,
} from "lucide-react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { AppLog } from "services";
import { Sheet, SheetContent } from "components/ui/sheet";

import { useLocation } from "react-router-dom";
import SearchBar from "components/app/search-bar/SearchBar";
import InfiniteScroll from "react-infinite-scroll-component";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import ImageUrl from "components/app/image-url/ImageUrl";
import { ShimmerDepartmentRender, ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";
import { Label } from "components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import TextInput from "components/app/function/TextInput";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";
import { setIndexTimeSheet } from "store/header";
import DatePicker from "components/app/function/DatePicker";
import DialogReportAttendanceTimesheets from "./dialogTimesheets/DialogReportAttendanceTimesheets";
import { noneProfile } from "assets";
import { Snackbar } from "components";
import DailogRecalculate from "./dialogTimesheets/DailogRecalculate";
import DailogSendReport from "./dialogTimesheets/DailogSendReport";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import { Service } from "utils/services";
import { Button } from "components/ui/button";
import TimePicker from "components/app/function/TimePicker";
import appStore from "store/appStore";
import TimeSheetSetting from "./TimeSheetSetting";
import PageReportAttendanceTimesheets from "./dialogTimesheets/PageReportAttendanceTimesheets";
import useUrlString from "./useUrlString";

export default function TimeSheet() {
  const location = useLocation();
  const [dob, setDob] = useState(new Date().toISOString().split("T")[0]); // "2025-05-05"
  const { showDialogMessage } = appStore();

  const [isDailogTimesheets, setIsDailogTimesheets] = useState<boolean>(false);
  const [isDailogRecalculate, setIsDailogRecalculate] = useState<boolean>(false);
  const [isDailogSendReport, setIsDailogSendReport] = useState<boolean>(false);
  const dispatch = useDispatch();

  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const [view, setView] = useState("card");
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("employeeTimesheets", selectedView);
  };

  useState<boolean>(false);
  const { token } = useAppSelector((state) => state.auth);
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);

  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);

  const [hovered, setHovered] = useState(false);
  const handleClickDepartment = ({ departmentName }: { departmentName: string }) => {
    if (selectedProductGroupCode === departmentName) return;
    setSelectedProductGroupCode(departmentName);
    selectedProductGroupCodeRef.current = departmentName;
  };
  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };

  // -----------------------------shop Employee-------------------------------------
  const [shopEmployeeTimesheets, setShopEmployeeTimesheets] = useState<any>();
  const [shopEmployeeLoading, setShopEmployeeLoading] = useState<any>(null);
  const [shopEmployeeLoadingState, setShopEmployeeLoadingState] = useState<any>(null);
  const { bntSearch } = useAppSelector((state) => state.header);

  const getShopEmployeeTimesheetSearch = async () => {
    setShopEmployeeLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeTimesheetSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeLoadingState(false);
        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["employee_timesheets"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["employee_timesheets"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployeeTimesheets(response.employee_timesheets);
        setShopEmployeeLoading(stateRecord);
      } else {
        console.log(response, "error fetch shop employee ");
        setShopEmployeeLoadingState(false);
      }
    } catch (error) {
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const fetchMoreShopEmployeeTimesheetSearch = async ({ next }: { next: string }) => {
    if (!next) return;

    setShopEmployeeLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["employee_timesheets"]["data"];
        const nextPage = responses["employee_timesheets"]["next_page_url"];

        const updatedData = [...(shopEmployeeTimesheets?.data || []), ...newEmployees];

        setShopEmployeeTimesheets({
          ...responses["employee_timesheets"],
          data: updatedData,
        });

        setShopEmployeeLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };
  const listRef = useRef<any>(null);
  // const listRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (listRef.current && shopEmployeeLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      fetchMoreShopEmployeeTimesheetSearch({
        next: shopEmployeeLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopEmployeeTimesheets?.data]);
  useEffect(() => {
    const savedView = localStorage.getItem("employeeTimesheets");
    if (savedView) {
      setView(savedView);
    }
    getShopEmployeeTimesheetSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput, selectedProductGroupCode, dob, bntSearch]);

  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const [departmentTimeSheet, setDepartmentTimeSheet] = useState<any>();
  const [loadingDepartmentTimeSheet, setloadingDepartmentTimeSheet] = useState<boolean>(false);
  const [attendanceSetting, setAttendanceSetting] = useState<any>({
    early_exception: "",
    late_exception: "",
    alert_telegram_lang: "",
  });
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);

  const fetchDepartmentTimeSheet = async () => {
    setloadingDepartmentTimeSheet(true);
    try {
      const url = `${RouteApi.getShopEmployeeTimesheetDepartment}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setloadingDepartmentTimeSheet(false);
        setDepartmentTimeSheet(response.user_shop_departments);
        setStorage_host_cluster_Id(response.storage_host_cluster);
        setAttendanceSetting({
          early_exception: response.attendance_setting.early_exception,
          late_exception: response.attendance_setting.late_exception,
          // --------
          max_compassionate_leave: response.attendance_setting.max_compassionate_leave,
          max_change_day_off_leave: response.attendance_setting.max_change_day_off_leave,
          max_marriage_leave: response.attendance_setting.max_marriage_leave,
          max_maternity_leave: response.attendance_setting.max_maternity_leave,
          max_paternity_leave: response.attendance_setting.max_paternity_leave,
          max_special_leave: response.attendance_setting.max_special_leave,
          max_suspend_leave: response.attendance_setting.max_suspend_leave,
          max_unpaid_leave: response.attendance_setting.max_unpaid_leave,
          annual_leave: response.attendance_setting.annual_leave,
          sick_leave: response.attendance_setting.sick_leave,
          max_block_leave: response.attendance_setting.max_block_leave,
          max_sick_leave: response.attendance_setting.max_sick_leave,
          max_annual_leave: response.attendance_setting.max_annual_leave,
          alart_telegram: response.attendance_setting.alart_telegram,
          alert_telegram_id: response.attendance_setting.alert_telegram_id,
          alert_telegram_lang: response.attendance_setting.alert_telegram_lang,
        });
      } else {
        setloadingDepartmentTimeSheet(false);
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error) {
      setloadingDepartmentTimeSheet(false);
      AppLog.show({
        message: `[fetchDepartmentTimeSheet]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  useEffect(() => {
    fetchDepartmentTimeSheet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // -------------------function select all ------------------
  const { indexTimeSheet } = useAppSelector((state) => state.header);
  const allIds = Array.isArray(shopEmployeeTimesheets?.data) ? shopEmployeeTimesheets?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      // Deselect all
      setSelectedProductIds([]);
    } else {
      // Select all
      setSelectedProductIds(allIds);
    }
  };
  const [itemsDetail, setItemDetail] = useState<any>();
  const dataTimesheets = [
    {
      id: 1,
      title: "Recalculate",
      label: " Recalculate employee timesheets.",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <Calculator />
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm text-gray-800">Recalculate totals based on the latest timesheet data and changes.</p>
          <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
            <li>Updates total working hours, overtime, and payroll calculations.</li>
            <li>Ensures all edits (clock-ins, breaks, shifts) are accurately reflected.</li>
            <li>Run this after importing, editing, or approving timesheets.</li>
          </ul>
        </>,
      ],
    },
  ];
  const handleClick = (title: string) => {
    if (title === "Recalculate") {
      setIsDailogRecalculate(true);
    } else {
      Snackbar({
        message: `Coming soon ${title}`,
        status: StatusMsg.warning,
      });
    }
    // }, 300); // simulate a short delay
  };
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);
  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-timesheet-report?token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        storage_host_cluster_id: storage_host_cluster_Id.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const handlePrintMonthly = async () => {
    setLoadingPrint(true);
    try {
      const url = `${storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-timesheet-monthly-report?token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        search_text: searchTextInput,
        employee_id: itemsDetail?.employee_id,
        storage_host_cluster_id: storage_host_cluster_Id.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);
        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[handlePrintMonthly]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  // ===============attendance setting=========
  const [openPopoverSetting, setOpenPopoverSetting] = useState<number | null>(null);

  const [timeInValues, setTimeInValues] = useState<string[]>([]);
  const [breakInValues, setBreakInValues] = useState<string[]>([]);
  const [timeOutValues, setTimeOutValues] = useState<string[]>([]);
  const [breakOutValues, setbreakOutValues] = useState<string[]>([]);
  useEffect(() => {
    if (shopEmployeeTimesheets?.data?.length) {
      const initialTimeIn = shopEmployeeTimesheets.data.map((item: any) => item.in_time || item.starting_time || "");
      const initialBreakOut = shopEmployeeTimesheets.data.map((item: any) => item.break_out_time || item.break_starting_time || "");
      const initialBreakIn = shopEmployeeTimesheets.data.map((item: any) => item.break_in_time || item.break_ending_time || "");
      const initialTimeOut = shopEmployeeTimesheets.data.map((item: any) => item.out_time || item.ending_time || "");
      setTimeInValues(initialTimeIn);
      setbreakOutValues(initialBreakOut);
      setBreakInValues(initialBreakIn);
      setTimeOutValues(initialTimeOut);
    }
  }, [shopEmployeeTimesheets]);

  const handleChangeTimeIn = (index: number, val: string) => {
    setTimeInValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  const handleChangeBreakOut = (index: number, val: string) => {
    setbreakOutValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  const handleChangeBreakIn = (index: number, val: string) => {
    setBreakInValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  const handleChangeTimeOut = (index: number, val: string) => {
    setTimeOutValues((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });
  };
  // ===========submitUpdateClockTime===============
  const [openDrawer, setOpenDrawer] = useState<number | null>(null);

  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
  const [openPopoverIndex2, setOpenPopoverIndex2] = useState<number | null>(null);
  const [openPopoverIndex3, setOpenPopoverIndex3] = useState<number | null>(null);
  const [openPopoverIndex4, setOpenPopoverIndex4] = useState<number | null>(null);

  const [loadingsubmitUpdateClockTime, setLoadingsubmitUpdateClockTime] = useState<boolean>(false);
  const submitUpdateClockTime = async (working_mode: string, id: number, index: number) => {
    setLoadingsubmitUpdateClockTime(true);
    try {
      const url = `${RouteApi.submitUpdateClockTime}token=${token}`;
      const data = {
        shop_id: shopId,
        id: id,
        working_mode: working_mode,
        working_time:
          (working_mode === "Time In"
            ? timeInValues[index]
            : working_mode === "Break Out"
            ? breakOutValues[index]
            : working_mode === "Break In"
            ? breakInValues[index]
            : timeOutValues[index]) ?? "",
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingsubmitUpdateClockTime(false);
        // setShopEmployeeTimesheets((prev: any) => ({
        //   ...prev,
        //   data: prev.data.map((item: any) =>
        //     item.id === response.employee_timesheet.id
        //       ? {
        //           ...item,
        //           in_time: response.employee_timesheet.in_time,
        //           break_out_time: response.employee_timesheet.break_out_time,
        //           break_in_time: response.employee_timesheet.break_in_time,
        //           out_time: response.employee_timesheet.out_time,
        //           actual_working_hour: response.employee_timesheet.actual_working_hour,
        //           late_in: response.employee_timesheet.late_in,
        //         }
        //       : item
        //   ),
        // }));
        setOpenPopoverIndex(null); // ✅ CLOSE the popover
        setOpenPopoverIndex2(null); // ✅ CLOSE the popover
        setOpenPopoverIndex3(null); // ✅ CLOSE the popover
        setOpenPopoverIndex4(null); // ✅ CLOSE the popover
        setShopEmployeeTimesheets((prev: any) => ({
          ...prev,
          data: prev.data.map((item: any) => (item.id === response.employee_timesheet.id ? response.employee_timesheet : item)),
        }));
      } else {
        setLoadingsubmitUpdateClockTime(false);
        showDialogMessage({
          title: response.status,
          message: response.msg,
          barrierDismissible: false,
        });
      }
    } catch (error) {
      setLoadingsubmitUpdateClockTime(false);
      AppLog.show({
        message: `[submitUpdateClockTime]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const [employeeTimesheetDetail, setEmployeeTimesheetDetail] = useState<any>();
  const [shopEmployeeDetailLoadingState, setShopEmployeeDetailLoadingState] = useState<any>(null);
  const getShopEmployeeTimesheetDetail = async (id: any) => {
    setShopEmployeeDetailLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeTimesheetDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        working_date: dob,
        employee_id: id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeDetailLoadingState(false);
        setEmployeeTimesheetDetail(response.employee_timesheets);
      } else {
        console.log(response, "error fetch shop employee ");
      }
    } catch (error) {
      setShopEmployeeDetailLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeTimesheetDetail]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("employee_id");
    if (requestId) {
      (async () => {
        await getShopEmployeeTimesheetDetail(requestId);
        setOpenDrawer(1);
      })();
    }
  }, []);
  const handleClickUrl = (id: string, urlString: string, working_data: any) => {
    const params = new URLSearchParams(location.search);
    const existingId = params.get("id"); // assuming ?id=... is required
    if (existingId) {
      const url = new URL(window.location.href);
      url.searchParams.set(urlString, id); // add or update param
      url.searchParams.set("working_data", working_data); // add or update param

      window.history.pushState({}, "", url.toString());
    }
  };
  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white sticky top-0 dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="text-start lg:w-auto md:w-auto w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Timesheets</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Smart Scheduling, Attendance, and Performance Tracking</p>
          </div>
          {warning ? (
            ""
          ) : (
            <nav className="border-gray-200 pt-5 flex items-center justify-between">
              <div className="flex items-center gap-3  ">
                {selectProducts && (
                  <div className="flex items-center justify-center px-5 py-2 bg-blue-500 rounded-full text-white">
                    Employee Selected {selectedProductIds.length} / {allIds.length}
                  </div>
                )}
                <>
                  {!selectProducts ? (
                    <></>
                  ) : (
                    <>
                      {selectedProductIds.length > 0 && (
                        <>
                          <Popover>
                            <PopoverTrigger asChild>
                              <label className=" font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300">
                                <AlignJustify />
                              </label>
                            </PopoverTrigger>
                            <PopoverContent className="w-80 relative">
                              {dataTimesheets?.map((item: any, index: any) => {
                                return (
                                  <HoverCardDetail title={item.title} description={item.description}>
                                    <div
                                      key={index}
                                      className="gap-3 group  flex items-center px-3 py-2 rounded-md hover:bg-accent cursor-pointer"
                                      onClick={() => {
                                        handleClick(item.title);
                                      }}
                                    >
                                      <span className="group-hover:scale-110 transition-all duration-300">{item.icon}</span>

                                      <div className="flex flex-col ">
                                        <span className="font-medium leading-none lg:text-md md:text-sm text-[13px]">{item.title}</span>
                                        <span className="text-sm text-muted-foreground line-clamp-1">{item.label} </span>
                                      </div>
                                    </div>
                                  </HoverCardDetail>
                                );
                              })}
                            </PopoverContent>
                          </Popover>
                        </>
                      )}
                    </>
                  )}
                </>
                {!selectProducts ? (
                  <>
                    <HoverCardDetail
                      title="Select"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select this item to perform actions like editing, deleting, or exporting.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Use checkboxes to include or exclude specific records.</li>
                            <li>Selected items can be affected by bulk actions.</li>
                            <li>Combine with “Select All” to manage groups efficiently.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        htmlFor=""
                        className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold  rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <CircleStop
                          onClick={() => {
                            dispatch(setIndexTimeSheet(""));
                            setSelectProducts(true);
                          }}
                          className="text-sm"
                        />
                      </label>
                    </HoverCardDetail>
                  </>
                ) : (
                  <>
                    <HoverCardDetail
                      title="Select all staff timesheets "
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select all staff records or timesheets currently displayed for bulk actions.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Enables efficient management of multiple items at once.</li>
                            <li>Useful for batch printing, editing, or deleting.</li>
                            <li>Double-check your selection before proceeding.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        className={`hover:scale-110  transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 
                                  flex items-center justify-center cursor-pointer border 
                                  ${isAllSelected ? "border-blue-500 border-2" : "border-gray-300"} text-md`}
                      >
                        <CircleCheck
                          onClick={() => {
                            handleToggleSelectAll();
                          }}
                          className={`${isAllSelected ? "bg-blue-500 text-white rounded-full" : " rounded-full"} hover:border-3 `}
                        />
                      </label>
                    </HoverCardDetail>
                    <HoverCardDetail
                      title="Select"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select this item to perform actions like editing, deleting, or exporting.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Use checkboxes to include or exclude specific records.</li>
                            <li>Selected items can be affected by bulk actions.</li>
                            <li>Combine with “Select All” to manage groups efficiently.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        htmlFor=""
                        className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <CircleOff
                          onClick={() => {
                            setSelectedProductIds([]);
                            setSelectProducts(false);
                          }}
                          className="text-sm"
                        />
                      </label>
                    </HoverCardDetail>
                  </>
                )}
              </div>

              {/* Search & View Switch */}
              {loadingPrint ? (
                <label
                  onClick={() => {
                    handlePrint();
                  }}
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <Loader className="animate-spin" />
                </label>
              ) : (
                <HoverCardDetail
                  title="Daily Attendance Detail Report"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm text-gray-800">View and analyze detailed attendance records for each employee on a daily basis.</p>
                      <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                        <li>Monitor clock-in/out times, absences, and late entries.</li>
                        <li>Track working hours, overtime, and shift compliance.</li>
                        <li>Export reports for HR reviews or payroll processing.</li>
                        <li>Identify patterns for attendance-related issues.</li>
                      </ul>
                    </>
                  }
                >
                  <label
                    onClick={() => {
                      handlePrint();
                    }}
                    htmlFor=""
                    className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                  >
                    <PrinterCheck />
                  </label>
                </HoverCardDetail>
              )}
              {/* open={setting} */}
              <Popover open={openPopoverSetting === 1} onOpenChange={(isOpen) => setOpenPopoverSetting(isOpen ? 1 : null)}>
                <PopoverTrigger asChild>
                  <label
                    htmlFor=""
                    className="hover:border-3  transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                  >
                    <Settings />
                  </label>
                </PopoverTrigger>
                <PopoverContent className="w-auto  h-[calc(100vh-200px)] overflow-scroll">
                  <TimeSheetSetting setAttendanceSetting={setAttendanceSetting} attendanceSetting={attendanceSetting} setOpenPopoverSetting={setOpenPopoverSetting} />
                </PopoverContent>
              </Popover>

              <div className="flex items-center gap-2 ms-5">
                <DatePicker
                  className="py-4 h-[40px] w-[150px] border border-gray-300"
                  onChange={(value: any) => {
                    setDob(value);
                  }}
                  value={dob}
                />
              </div>
              <div className="flex items-center gap-2">
                <div className="flex-1 ms-4 me-2">
                  <div className="relative">
                    <SearchBar
                      placeholder="Search"
                      onValueChange={(value) => {
                        setSearchTextInput(value);
                      }}
                    />
                  </div>
                </div>

                {/* View Toggle Button */}
                <HoverCardDetail
                  title=""
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">Switch between different layouts to view employee timesheets records in the format you prefer.</p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>
                          <strong>Card View:</strong> Shows each employee timesheets as an individual card with profile info and actions.
                        </li>
                        <li>
                          <strong>Table View:</strong> Displays employees timesheets in a structured table for sorting, scanning, and bulk actions.
                        </li>
                        <li>Use the layout that best suits your workflow or screen size.</li>
                      </ul>
                    </>
                  }
                >
                  <div className="relative">
                    {view === "card" ? (
                      <button
                        onClick={() => changeView("table")}
                        className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <Grid2x2 className="font-semibold size-5" />
                      </button>
                    ) : (
                      <button
                        onClick={() => changeView("card")}
                        className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <WalletCards className="text-xl" />
                      </button>
                    )}
                  </div>
                </HoverCardDetail>
              </div>
            </nav>
          )}
        </div>
        {/* scrollCategories */}
        {warning ? (
          ""
        ) : (
          <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
          >
            {/* Hover Overflow Scroll Container */}
            <div className="relative w-full ">
              <div className="flex space-x-2 w-full">
                {/* Add Category */}

                {/* "All" Category */}
                <div
                  onClick={() => {
                    if (selectedProductGroupCode === "All") {
                    }
                    handleClickDepartment({
                      departmentName: "",
                    });
                  }}
                  className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                    selectedProductGroupCode === "" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
                  }`}
                >
                  <span className="lg:text-sm md:text-sm text-[12px]">All</span>
                </div>
                {/* Product Categories */}
                <div className="space-x-2 flex">
                  {loadingDepartmentTimeSheet ? (
                    <>
                      <ShimmerDepartmentRender />
                    </>
                  ) : (
                    <>
                      {departmentTimeSheet?.map((department: any) => (
                        <div key={department.id} className="flex items-center">
                          <div
                            className={`flex items-center  w-auto whitespace-nowrap lg:h-14 md:h-12 h-10  border rounded-md cursor-pointer font-semibold 
                                ${
                                  selectedProductGroupCode === (department?.department ? department.department.toString() : "")
                                    ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200"
                                    : "dark:hover:bg-slate-900"
                                }`}
                            onClick={() => {
                              handleClickDepartment({
                                departmentName: department?.department ?? "", // Ensure it's a string or fallback to ""
                              });
                            }}
                          >
                            <div className="flex group ">
                              <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden flex items-center justify-center">
                                {department?.department ?? "No department"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              errorStatus?.title === "success" || errorStatus?.title === "info" ? "text-green-500" : errorStatus?.title === "warning" ? "text-yellow-500" : "text-red-500"
            }`}
          >
            {errorStatus?.title === "success" ? "Success" : errorStatus?.title === "info" ? "Infomation" : errorStatus?.title === "warning" ? "Warning" : "Error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{errorStatus?.message}</span>
        </div>
      ) : (
        <div className="pb-3 h-full mt-5 bg-red">
          {view === "card" ? (
            <>
              {shopEmployeeLoadingState ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <InfiniteScroll
                  dataLength={shopEmployeeTimesheets?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeeTimesheetSearch({
                      next: shopEmployeeLoading.nextPageUrl,
                    })
                  }
                  hasMore={!!shopEmployeeLoading?.nextPageUrl}
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    <div ref={listRef} className={`grid  md:grid-cols-5 grid-cols-2 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"}  gap-y-3 gap-x-2 mb-10   `}>
                      {shopEmployeeTimesheets?.data?.map((item: any, index: number) => {
                        // console.log(shopEmployeeTimesheets, "In time ");

                        return (
                          <div
                            onClick={() => {
                              if (selectProducts) {
                                setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                return;
                              } else {
                                // dispatch(setIndexTimeSheet(item.id));
                              }
                            }}
                            key={index}
                            className={`group   relative z-1 w-full max-w-sm border rounded-lg  ${selectedProductIds.includes(item.id) ? " " : ""}`}
                          >
                            <div className=" w-full relative overflow-hidden aspect-square  ">
                              <ImageUrl className="rounded-t-md w-full h-full  object-cover " src={!item.picture ? noneProfile : item.picture} alt="" />
                              <div
                                className={` ${
                                  selectedProductIds.includes(item.id) ? "bg-white" : ""
                                } w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                              >
                                {selectedProductIds.includes(item.id) ? (
                                  <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                ) : (
                                  <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                )}
                              </div>
                              <HoverCardDetail
                                title="Monthly Attendance Detail Report"
                                description={
                                  <>
                                    <p className="mb-2 font-medium text-sm dark:text-white">Generate and print detailed timesheets for employees to track hours worked.</p>
                                    <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                      <li>Includes clock-in/out times, breaks, and total hours.</li>
                                      <li>Useful for payroll, attendance verification, and compliance.</li>
                                      <li>Customize date ranges and filters before printing.</li>
                                      <li>Export options may be available (PDF, Excel, etc.).</li>
                                    </ul>
                                  </>
                                }
                              >
                                <div
                                  onClick={() => {
                                    // setIsDailogTimesheets(true);
                                    setOpenDrawer(1);
                                    setItemDetail({ ...item, dob });
                                    getShopEmployeeTimesheetDetail(item.employee_id);
                                    handleClickUrl(item?.employee_id, "employee_id", dob);
                                  }}
                                  className={`${
                                    selectProducts ? " hidden" : " block"
                                  } cursor-pointer group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute right-2 top-2`}
                                >
                                  <Calendar className="" />
                                </div>
                              </HoverCardDetail>
                            </div>
                            <div className={`p-4 ${indexTimeSheet === item.id ? "bg-gray-200 dark:bg-[#0e172c] rounded-b-md " : ""} `}>
                              <h4 className="text-md font-semibold line-clamp-2 overflow-hidden h-[25px] text-[15px] ">{item?.local_name}</h4>
                              <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>

                              <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.position}</p>

                              <div key={index} className="flex items-center justify-between">
                                <Popover open={openPopoverIndex === index} onOpenChange={(isOpen) => setOpenPopoverIndex(isOpen ? index : null)}>
                                  <PopoverTrigger asChild>
                                    <p
                                      className={`font-semibold text-[15px] h-[20px] cursor-pointer ${
                                        !item.starting_time
                                          ? "text-gray-500"
                                          : !item.in_time
                                          ? "text-red-500"
                                          : item.in_time > item.starting_time
                                          ? item.late_in > attendanceSetting.late_exception
                                            ? "text-red-500"
                                            : item.late_in > 0
                                            ? "text-yellow-500"
                                            : ""
                                          : ""
                                      }`}
                                    >
                                      {!item.starting_time ? "OFF" : !item.in_time ? "A" : Service.formatTime(item.in_time)}
                                    </p>
                                  </PopoverTrigger>
                                  <PopoverContent className="w-auto">
                                    <div className="grid gap-4">
                                      <div className="space-y-2">
                                        <h4 className="font-medium leading-none">Time In</h4>
                                      </div>
                                      <div className="flex items-center gap-2 ">
                                        <TimePicker className="" value={timeInValues[index] || ""} onChange={(val) => handleChangeTimeIn(index, val)} />

                                        <div className="flex justify-end items-center gap-4">
                                          <Button
                                            className="px-5 dark:text-white"
                                            onClick={() => {
                                              submitUpdateClockTime("Time In", item.id, index);
                                            }}
                                          >
                                            {loadingsubmitUpdateClockTime ? <Loader className="animate-spin" /> : "Save"}
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </PopoverContent>
                                </Popover>
                                <Popover open={openPopoverIndex4 === index} onOpenChange={(isOpen) => setOpenPopoverIndex4(isOpen ? index : null)}>
                                  <PopoverTrigger asChild>
                                    <p
                                      className={`
                                      cursor-pointer
                                   font-semibold text-[15px] h-[20px]
                                    ${
                                      !item.ending_time
                                        ? "text-gray-500" // 1. OFF if no ending_time
                                        : !item.out_time
                                        ? "text-red-500" // 2. A if missing out_time
                                        : // 07:00:00 >13:30:00
                                        item.out_time < item.ending_time
                                        ? item.early_out > attendanceSetting.early_exception
                                          ? "text-red-500" // 4. Exceeds early_exception
                                          : item.early_out > 0
                                          ? "text-yellow-500" // 3. Within early_exception
                                          : ""
                                        : ""
                                    }
  `}
                                    >
                                      {!item.ending_time ? "OFF" : !item.out_time ? "A" : Service.formatTime(item.out_time)}
                                    </p>
                                  </PopoverTrigger>
                                  <PopoverContent className="w-auto">
                                    <div className="grid gap-4">
                                      <div className="space-y-2">
                                        <h4 className="font-medium leading-none">Time Out</h4>
                                      </div>
                                      <div className="flex items-center gap-2 ">
                                        <TimePicker className="" value={timeOutValues[index] || ""} onChange={(val) => handleChangeTimeOut(index, val)} />

                                        <div className="flex justify-end items-center gap-4">
                                          <Button
                                            className="px-5 dark:text-white"
                                            onClick={() => {
                                              submitUpdateClockTime("Time Out", item.id, index);
                                            }}
                                          >
                                            {loadingsubmitUpdateClockTime ? <Loader className="animate-spin" /> : "Save"}
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </PopoverContent>
                                </Popover>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {!shopEmployeeTimesheets?.next_page_url ? (
                        <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                          <b>Nothing more to load!</b>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                </InfiniteScroll>
              )}
            </>
          ) : (
            <>
              {shopEmployeeTimesheets ? (
                <InfiniteScroll
                  dataLength={shopEmployeeTimesheets?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeeTimesheetSearch({
                      next: shopEmployeeLoading.nextPageUrl,
                    })
                  }
                  scrollThreshold="90%"
                  hasMore={!!shopEmployeeLoading.nextPageUrl}
                  scrollableTarget="scrollableDiv"
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    {shopEmployeeLoadingState ? (
                      <SkeletonMusicLibrariesTable />
                    ) : (
                      <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
                        <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
                          <tr className="border-none text-[15px]">
                            <th className=" py-5 px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                            <th className="px-4 text-start text-nowrap">Staff Info. </th>
                            <th className="px-4 text-start text-nowrap">Department</th>
                            <th className="px-4 text-start text-nowrap">Time In</th>
                            <th className="px-4 text-start text-nowrap">Break Out</th>
                            <th className="px-4 text-start text-nowrap">Break (In)</th>
                            <th className="px-4 text-start text-nowrap">Time Out</th>
                            <th className="px-4 text-start text-nowrap">Hour</th>
                            <th className="px-4 text-start text-nowrap">Leave</th>
                            <th className="px-4 text-start text-nowrap">Remark</th>
                          </tr>
                        </thead>
                        <tbody ref={listRef}>
                          {shopEmployeeTimesheets?.data?.map((item: any, index: number) => {
                            return (
                              <tr
                                onClick={() => {
                                  if (selectProducts) {
                                    setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                    return;
                                  } else {
                                    dispatch(setIndexTimeSheet(item.id));
                                  }
                                }}
                                key={index}
                                className={`text-center group cursor-pointer ${
                                  index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "
                                } hover:bg-gray-300`}
                              >
                                <td className="relative w-[120px] h-[120px]">
                                  <div
                                    className={` ${
                                      selectedProductIds.includes(item.id) ? "bg-white" : ""
                                    } w-4 h-4 rounded-full flex items-center z-50 justify-center absolute left-[6px] top-[6px] text-xl  ${!selectProducts ? " hidden" : " block"}`}
                                  >
                                    {selectedProductIds.includes(item.id) ? (
                                      <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                    ) : (
                                      <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                                    )}
                                  </div>
                                  <HoverCardDetail
                                    title="Monthly Attendance Detail Report"
                                    description={
                                      <>
                                        <p className="mb-2 font-medium text-sm dark:text-white">Generate and print detailed timesheets for employees to track hours worked.</p>
                                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                          <li>Includes clock-in/out times, breaks, and total hours.</li>
                                          <li>Useful for payroll, attendance verification, and compliance.</li>
                                          <li>Customize date ranges and filters before printing.</li>
                                          <li>Export options may be available (PDF, Excel, etc.).</li>
                                        </ul>
                                      </>
                                    }
                                  >
                                    <div
                                      onClick={() => {
                                        // setIsDailogTimesheets(true);
                                        setOpenDrawer(1);
                                        setItemDetail({ ...item, dob });
                                        handleClickUrl(item?.employee_id, "employee_id", dob);
                                        getShopEmployeeTimesheetDetail(item.employee_id);
                                      }}
                                      className={`${
                                        selectProducts ? " hidden" : " block"
                                      } group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute z-50 right-[6px] top-2`}
                                    >
                                      <Calendar className="" />
                                    </div>
                                  </HoverCardDetail>

                                  <ImageUrl src={!item.picture ? noneProfile : item.picture} className="w-[120px] h-[120px] z-1 mx-auto relative" alt="" />
                                </td>
                                <td className="py-2 px-4 text-md text-left align-top">
                                  <p className="text-[15px] font-bold my-2">{item.card_no}</p>
                                  <p className="text-[15px]  my-2">{item.local_name}</p>
                                  <p className="text-md">{item.english_name}</p>
                                </td>

                                <td className="py-2 px-4 text-md  text-left align-top  ">
                                  <p className="text-md line-clamp-1 my-2"> {item?.department}</p>
                                  <p className="text-md "> {item?.position}</p>
                                  <div className="flex items-center gap-1 text-muted-foreground">
                                    <p className="text-md text-nowrap"> {Service.formatTime(item?.starting_time)}</p>
                                    {item?.starting_time && item?.ending_time && "-"}
                                    <p className="text-md text-nowrap "> {Service.formatTime(item?.ending_time)}</p>
                                  </div>
                                </td>

                                <td className="py-2 px-4 text-left align-top">
                                  <Popover open={openPopoverIndex === index} onOpenChange={(isOpen) => setOpenPopoverIndex(isOpen ? index : null)}>
                                    <PopoverTrigger asChild>
                                      <p
                                        className={`
                                           text-[15px] font-bold text-nowrap my-2
                                            ${
                                              !item.starting_time
                                                ? "text-gray-500"
                                                : !item.in_time
                                                ? "text-red-500"
                                                : item.in_time > item.starting_time
                                                ? item.late_in > attendanceSetting.late_exception
                                                  ? "text-red-500"
                                                  : item.late_in > 0
                                                  ? "text-yellow-500"
                                                  : ""
                                                : ""
                                            }`}
                                      >
                                        {!item.starting_time ? "OFF" : !item.in_time ? "A" : Service.formatTime(item.in_time)}
                                      </p>
                                    </PopoverTrigger>
                                    <PopoverContent className="w-auto">
                                      <div className="grid gap-4">
                                        <div className="space-y-2">
                                          <h4 className="font-medium leading-none">Time In</h4>
                                        </div>
                                        <div className="flex items-center gap-2 ">
                                          <TimePicker className="" value={timeInValues[index] || ""} onChange={(val) => handleChangeTimeIn(index, val)} />

                                          <div className="flex justify-end items-center gap-4">
                                            <Button
                                              className="px-5 dark:text-white"
                                              onClick={() => {
                                                submitUpdateClockTime("Time In", item.id, index);
                                              }}
                                            >
                                              {loadingsubmitUpdateClockTime ? <Loader className="animate-spin" /> : "Save"}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverContent>
                                  </Popover>
                                  <p className="text-sm text-muted-foreground text-nowrap  ">
                                    {" "}
                                    {!item?.late_in ? (item?.early_in !== 0 ? item?.early_in + " Minutes Early" : "") : item?.late_in !== 0 ? item?.late_in + " Minutes Late" : ""}
                                  </p>
                                  <p className="text-sm text-muted-foreground text-nowrap  ">{item.in_remark}</p>
                                </td>
                                {/* in time */}
                                <td className="py-2 px-4 text-[15px] text-nowrap text-left align-top ">
                                  <Popover open={openPopoverIndex2 === index} onOpenChange={(isOpen) => setOpenPopoverIndex2(isOpen ? index : null)}>
                                    <PopoverTrigger asChild>
                                      <p
                                        className={`
                                        font-bold my-2
                                         ${
                                           !item.break_starting_time
                                             ? "text-gray-500" // OFF
                                             : !item.break_out_time
                                             ? "text-red-500" // A
                                             : "text-black dark:text-white" // Time present
                                         }
                                       `}
                                      >
                                        {!item.break_starting_time ? "" : !item.break_out_time ? "A" : Service.formatTime(item.break_out_time)}
                                      </p>
                                    </PopoverTrigger>
                                    <PopoverContent className="w-auto">
                                      <div className="grid gap-4">
                                        <div className="space-y-2">
                                          <h4 className="font-medium leading-none">Break Out</h4>
                                        </div>
                                        <div className=" flex items-center gap-2 ">
                                          <TimePicker className="" value={breakOutValues[index] || ""} onChange={(val) => handleChangeBreakOut(index, val)} />

                                          <div className="flex justify-end items-center gap-4">
                                            <Button
                                              className="px-5 dark:text-white"
                                              onClick={() => {
                                                submitUpdateClockTime("Break Out", item.id, index);
                                              }}
                                            >
                                              {loadingsubmitUpdateClockTime ? <Loader className="animate-spin" /> : "Save"}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverContent>
                                  </Popover>

                                  <p className="text-sm text-muted-foreground text-nowrap my-2  ">
                                    {" "}
                                    {!item?.late_break_out
                                      ? item?.early_break_out !== 0
                                        ? item?.early_break_out + " Minutes Early"
                                        : ""
                                      : item?.late_break_out !== 0
                                      ? item?.late_break_out + "   Minutes Late"
                                      : ""}{" "}
                                  </p>
                                  <p className="text-sm text-muted-foreground text-nowrap  ">{item.break_out_remark}</p>
                                </td>
                                {/* break out */}

                                <td className="py-2 px-4 text-[15px] text-nowrap text-left align-top ">
                                  <Popover open={openPopoverIndex3 === index} onOpenChange={(isOpen) => setOpenPopoverIndex3(isOpen ? index : null)}>
                                    <PopoverTrigger asChild>
                                      <p
                                        className={`
                                        font-bold my-2
                                        ${
                                          !item.break_starting_time
                                            ? "text-gray-500" // OFF
                                            : !item.break_in_time
                                            ? "text-red-500" // A
                                            : "text-black dark:text-white" // Valid break_in_time
                                        }
                                           `}
                                      >
                                        {!item.break_starting_time ? "" : !item.break_in_time ? "A" : Service.formatTime(item.break_in_time)}
                                      </p>
                                    </PopoverTrigger>
                                    <PopoverContent className="w-auto">
                                      <div className="grid gap-4">
                                        <div className="space-y-2">
                                          <h4 className="font-medium leading-none">Break In</h4>
                                        </div>
                                        <div className="flex items-center gap-2 ">
                                          <TimePicker className="" value={breakInValues[index] || ""} onChange={(val) => handleChangeBreakIn(index, val)} />

                                          <div className="flex justify-end items-center gap-4">
                                            <Button
                                              className="px-5 dark:text-white"
                                              onClick={() => {
                                                submitUpdateClockTime("Break In", item.id, index);
                                              }}
                                            >
                                              {loadingsubmitUpdateClockTime ? <Loader className="animate-spin" /> : "Save"}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverContent>
                                  </Popover>
                                  {/* late_break_in early_break_in */}
                                  <p className="text-sm text-muted-foreground text-nowrap my-2 ">
                                    {" "}
                                    {!item?.late_break_in
                                      ? item?.early_break_in !== 0
                                        ? item?.early_break_in + " Minutes Early"
                                        : ""
                                      : item?.late_break_in !== 0
                                      ? item?.late_break_in + "Minutes Late"
                                      : ""}
                                  </p>
                                  <p className="text-sm text-muted-foreground text-nowrap  ">{item.break_in_remark}</p>
                                </td>
                                {/* break in */}

                                {/* ====== */}

                                <td className="py-2 px-4  text-[15px]   text-left align-top text-nowrap ">
                                  <Popover open={openPopoverIndex4 === index} onOpenChange={(isOpen) => setOpenPopoverIndex4(isOpen ? index : null)}>
                                    <PopoverTrigger asChild>
                                      <p
                                        className={`
                                         text-[15px] font-bold text-nowrap my-2
                                         ${
                                           !item.ending_time
                                             ? "text-gray-500" // 1. OFF
                                             : !item.out_time
                                             ? "text-red-500" // 2. A
                                             : item.out_time < item.ending_time
                                             ? item.early_out > attendanceSetting.early_exception
                                               ? "text-red-500" // 4. Exceeds early_exception
                                               : item.early_out > 0
                                               ? "text-yellow-500" // 3. Within early_exception
                                               : ""
                                             : ""
                                         }
  `}
                                      >
                                        {!item.ending_time ? "OFF" : !item.out_time ? "A" : Service.formatTime(item.out_time)}
                                      </p>
                                    </PopoverTrigger>
                                    <PopoverContent className="w-auto">
                                      <div className="grid gap-4">
                                        <div className="space-y-2">
                                          <h4 className="font-medium leading-none">Time Out</h4>
                                        </div>
                                        <div className="flex items-center gap-2 ">
                                          <TimePicker className="" value={timeOutValues[index] || ""} onChange={(val) => handleChangeTimeOut(index, val)} />

                                          <div className="flex justify-end items-center gap-4">
                                            <Button
                                              className="px-5 dark:text-white"
                                              onClick={() => {
                                                submitUpdateClockTime("Time Out", item.id, index);
                                              }}
                                            >
                                              {loadingsubmitUpdateClockTime ? <Loader className="animate-spin" /> : "Save"}
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    </PopoverContent>
                                  </Popover>

                                  <p className="text-sm text-muted-foreground text-nowrap my-2 ">
                                    {" "}
                                    {/* {!item?.late_out ? (item?.early_out !== 0 ? item?.early_out : "") : item?.late_out !== 0 ? item?.late_out + "Minutes Late" : ""} */}
                                    {!item?.late_out
                                      ? item?.early_out !== 0
                                        ? item?.early_out + " Minutes Early"
                                        : ""
                                      : item?.late_out !== 0
                                      ? item?.late_out + " Minutes Late"
                                      : ""}
                                  </p>
                                  <p className="text-sm text-muted-foreground text-nowrap  ">{item.out_remark}</p>
                                </td>
                                <td className="py-2 px-4 t text-nowrap text-left align-top ">
                                  <p className=" my-2 font-bold">{item?.actual_working_hour > 0 ? item?.actual_working_hour : ""}</p>
                                </td>
                                <td className="py-2 px-4  font-bold text-nowrap text-left align-top">
                                  {item.al > 0 && (
                                    <p className={`text-md line-clamp-1 my-2`}>
                                      {item.al > 0 ? "AL :" : ""} {item.al > 0 ? item.al : ""}
                                    </p>
                                  )}
                                  {item.sl > 0 && (
                                    <p className={`text-md line-clamp-1 my-2 `}>
                                      {item.sl > 0 ? "SL :" : ""} {item.sl > 0 ? item.sl : ""}
                                    </p>
                                  )}
                                  {item.ab > 0 && (
                                    <p className={`text-md line-clamp-1 my-2 text-red-500 `}>
                                      {item.ab > 0 ? "AB :" : ""} {item.ab > 0 ? item.ab : ""}
                                    </p>
                                  )}
                                </td>

                                <td className="py-2 px-4  text-left align-top">
                                  <p className="text-sm text-muted-foreground text-nowrap my-2 ">{item.remark}</p>
                                </td>
                              </tr>
                            );
                          })}
                          {!shopEmployeeTimesheets?.next_page_url ? (
                            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                              <b>Nothing more to load!</b>
                            </p>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </table>
                    )}
                  </>
                </InfiniteScroll>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      )}

      <Sheet
        open={openDrawer === 1}
        onOpenChange={(isOpen) => {
          setOpenDrawer(isOpen ? 1 : null);
          if (!isOpen) {
            const url = new URL(window.location.href);
            url.searchParams.delete("employee_id");
            url.searchParams.delete("working_data");
            window.history.pushState({}, "", url.toString());
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1100px] justify-between p-3 pt-[50px]">
          <PageReportAttendanceTimesheets
            employeeTimesheetDetail={employeeTimesheetDetail}
            setEmployeeTimesheetDetail={setEmployeeTimesheetDetail}
            shopEmployeeDetailLoadingState={shopEmployeeDetailLoadingState}
            setShopEmployeeDetailLoadingState={setShopEmployeeDetailLoadingState}
            setOpenDrawer={setOpenDrawer}
            attendanceSetting={attendanceSetting}
            loadingPrint={loadingPrint}
            onUploadSuccess={({ status }) => {
              if (status === "print") {
                handlePrintMonthly();
              } else {
              }
            }}
            isDailogTimesheets={isDailogTimesheets}
            setIsDailogTimesheets={setIsDailogTimesheets}
            itemsDetail={itemsDetail}
            dob={dob}
          />
        </SheetContent>
      </Sheet>
      <BtnGoToTop />
      <DailogRecalculate
        onUploadSuccess={({ status }) => {
          if (status === "success") {
            setSelectedProductIds([]);
            setSelectProducts(false);
          } else {
          }
        }}
        isDailogRecalculate={isDailogRecalculate}
        setIsDailogRecalculate={setIsDailogRecalculate}
        selectedProductIds={selectedProductIds}
      />
      <DailogSendReport isDailogSendReport={isDailogSendReport} setIsDailogSendReport={setIsDailogSendReport} selectedProductIds={selectedProductIds} />
    </BusinessSuiteContentLayout>
  );
}
